/* harmony-accordion — animates <details data-h-accordion> height on open/close.
   Delegated listener: one binding covers every accordion on the page and any
   injected later. Falls back to native instant toggle if JS never runs. */
(function () {
  if (window.__hAccordionBound) return;
  window.__hAccordionBound = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('[data-h-accordion] > summary');
    if (!summary) return;
    var details = summary.parentElement;
    var body = details.querySelector('[data-h-accordion-body]');
    if (!body || reduceMotion.matches) return; // let the native toggle happen
    if (details.dataset.hAnimating) return;
    e.preventDefault();
    details.dataset.hAnimating = '1';
    var done = function () { delete details.dataset.hAnimating; };
    if (details.open) {
      var from = body.offsetHeight;
      body.animate([{ height: from + 'px' }, { height: '0px' }], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' })
        .onfinish = function () { details.open = false; done(); };
    } else {
      /* Exclusive group (native `name` on <details>): animate the other open
         items closed. Dropping `name` first keeps the browser's own group
         exclusion from snapping them shut when `details` opens; siblings still
         mid-animation keep their name so the native rule closes them. */
      var group = details.getAttribute('name');
      if (group) {
        document.querySelectorAll('details[data-h-accordion][name="' + group + '"]').forEach(function (other) {
          if (other === details || !other.open || other.dataset.hAnimating) return;
          var obody = other.querySelector('[data-h-accordion-body]');
          other.dataset.hAnimating = '1';
          other.removeAttribute('name');
          var finish = function () {
            other.open = false;
            delete other.dataset.hAnimating;
            other.setAttribute('name', group);
          };
          if (!obody) { finish(); return; }
          var h = obody.offsetHeight;
          obody.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' })
            .onfinish = finish;
        });
      }
      details.open = true;
      var to = body.offsetHeight;
      body.animate([{ height: '0px' }, { height: to + 'px' }], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' })
        .onfinish = done;
    }
  });
})();
